"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  -webkit-user-select: none; /* Safari */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */\n  user-select: none; /* Standard */\n  .icon {\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    cursor: ", ";\n  }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
}, function (props) {
  return props.backgroundColor || props.background;
}, function (props) {
  return props.to ? 'pointer' : null;
});
var IconWrapper = function IconWrapper(Component) {
  var _Class;
  return _Class = /*#__PURE__*/function (_React$Component) {
    function _Class() {
      var _this;
      _classCallCheck(this, _Class);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _Class, [].concat(args));
      _this.onClick = function () {
        if (_this.props.onClick) {
          _this.props.onClick();
        }
      };
      return _this;
    }
    _inherits(_Class, _React$Component);
    return _createClass(_Class, [{
      key: "_icon",
      value: function _icon() {
        if (this.props.supplementIcon) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "supplement-icon-wrapper"
          }, /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, this.state)), /*#__PURE__*/_react["default"].createElement("div", {
            className: "supplement-icon"
          }, this.props.supplementIcon));
        }
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, this.state));
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Wrapper, {
          className: (0, _classnames["default"])('icon-wrapper', this.props.className, {
            active: this.props.active
          }),
          width: this.props.width,
          background: this.props.background,
          backgroundColor: this.props.backgroundColor,
          style: this.props.style,
          onClick: this.onClick
        }, this._icon());
      }
    }]);
  }(_react["default"].Component), _Class.propTypes = {
    onClick: _propTypes["default"].func,
    to: _propTypes["default"].object,
    className: _propTypes["default"].string,
    supplmentIcon: _propTypes["default"].object,
    active: _propTypes["default"].bool,
    activeText: _propTypes["default"].string
  }, _Class;
};
IconWrapper.displayName = 'IconWrapper';
var _default = exports["default"] = IconWrapper;